<template>
    <div class="lms__superadmin_users_edit">
        <div class="lms__superadmin_users_edit_header">
            <view-actions
                :title="`User: ${userDefaultName}`"
                :cancel-button-text="'Go back'"
                :cancel-notify-active="false"
                :submit-button-active="true"
                :submit-button-text="'Save changes'"
                :submit-button-animate-loading="true"
                :submit-button-animate-loading-event-name="'save-user'"
                :breadcrumb-active="true"
                @emit-cancel="userStopShow"
                @emit-submit="performSubmitValidate"
                :breadcrumb-items="[
                    {
                        name: 'Users',
                        to: userTo
                    }
                ]"
            />
        </div>
        <div class="lms__superadmin_users_edit_main">
            <div class="container">
                <div class="columns custom--centered">
                    <div class="column is-5-desktop is-7-tablet is-12-mobile">
                        <lms-superadmin-user-edit-form/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import LmsSuperadminUserEditForm from '@/components/lms/superadmin/users/edit/LmsSuperadminUsersEditForm'
import { performSubmitValidate, validateBeforeRouteLeave } from '@/helpers/mixins'

export default {
  name: 'lms-superadmin-admin-edit',
  components: {
    LmsSuperadminUserEditForm,
    ViewActions
  },
  mixins: [validateBeforeRouteLeave, performSubmitValidate],
  computed: {
    userProfileId () {
      return this.$store.getters.getLmsUserAccountId
    },
    userId () {
      return this.$store.getters.getLmsSuperadminUserId
    },
    userFirstName () {
      return this.$store.getters.getLmsSuperadminUserFirstName
    },
    userLastName () {
      return this.$store.getters.getLmsSuperadminUserLastName
    },
    userDefaultName () {
      return this.$store.getters.getLmsSuperadminUserDefaultName
    },
    userStatus () {
      return this.$store.getters.getLmsSuperadminUserStatus
    },
    userEmail () {
      return this.$store.getters.getLmsSuperadminUserEmail
    },
    userTo: function () {
      return { name: 'lms-superadmin-user-list' }
    },
    //
    watchContent () {
      return this.userFirstName + this.userLastName
    },
    //
    rootItemName () {
      return 'user'
    },
    nameActionUpdate () {
      return 'lmsSuperadminUserUpdate'
    },
    paramsActionUpdate () {
      return {
        id: this.userId,
        firstName: this.userFirstName,
        lastName: this.userLastName,
        emailAddress: this.userEmail,
        status: this.userStatus
      }
    },
    nameActionReset () {
      return 'lmsSuperadminAdminReset'
    }
  },
  methods: {
    allowRedirectBeforeRouteLeave () {
      this.$eventBus.$emit('user-submit')
    },
    performSubmitValidateThenCallback () {
      this.$router.push({ name: 'lms-superadmin-user-list' })
    },
    performSubmitValidateFinallyCallback () {
      this.$eventBus.$emit('stop-save-user')
    },
    //
    userStopShow () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'lms-superadmin-user-list' })
    },
    userEdit () {
      this.allowRedirectBeforeRouteLeave()
      this.router.push({ name: 'lms-superadmin-user-edit' })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/users/_lmssuperadminuseraddedit.scss";
</style>
